export default __webpack_public_path__ + "static/media/BohoHome.94b66110.jpg";